var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"dev-promo"},[_c('img',{attrs:{"src":"https://admin.shablon.bazis.kz/media/bazis-logo_2023.svg","alt":""}}),_c('h1',[_vm._v("САЙТ НАХОДИТСЯ В РАЗРАБОТКЕ")])])])])
}]

export { render, staticRenderFns }